import { useMemo } from 'react';
import { ImageDropdownItem, InputItemList } from '../models';
import { InputType } from '../enums';

export const GetImageDropdownItem = (inputs: InputItemList) => {

    return inputs.find(x => x.inputType == InputType.ImageDropdown) as ImageDropdownItem;
};
